import { getToken } from '@/store/authentication/authentication.selector'
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { switchMap, take } from 'rxjs/operators'
import { apiSettings } from '@common/constants'

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // Only attach the access token to OUR ECommerce API — never leak it to other origins (the Identity
    // discovery/userinfo endpoints, or any third-party URL). The token is `ecommerce_launchpad_api`-scoped
    // and meaningless (and unsafe) elsewhere. Match on the API ROOT (base + version), not just the base.
    // The organization is carried by the token's org_id claim — the server never reads it from a header.
    const apiRoot = `${apiSettings.ecommerceApiUrl}/${apiSettings.ecommerceApiVersion}`
    if (!request.url.startsWith(apiRoot)) {
      return next.handle(request)
    }

    // Read the token once (take(1) — no leaked per-request subscription) and attach it synchronously.
    return this.store.select(getToken).pipe(
      take(1),
      switchMap((token) => {
        const authorized =
          token && token.length > 0
            ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
            : request
        return next.handle(authorized)
      })
    )
  }
}
